module.exports = __webpack_public_path__ + "static/img/sf4.57f094f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/course/sf4.png
// module id = z9uA
// module chunks = 0